import React from 'react'
import MaterialUiCircularProgress from '@material-ui/core/CircularProgress'

const CircularProgress = props => {
  return (
    <div
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginTop: 125
      }}
    >
      <MaterialUiCircularProgress
        style={{ color: '#3b424d' }}
        thickness={2}
        size={75}
      />
    </div>
  )
}

export { CircularProgress }



// WEBPACK FOOTER //
// ./src/components/common/CircularProgress.js